import { TripleLineTemplate, withButtonsTamplate, DubleLineTemplate2 } from '../../../utils/formater';

export default function TableConfig() {
  return {
    columns: [
      {
        dataIndex: 'queue_name',
        title: 'Очередь',
        fixed: 'left',
        width: 170,
      },
      {
        dataIndex: '190',
        title: 'Кол-во обработанных талонов с временем ожидания',
        render: (cell, row) => DubleLineTemplate2([
          {
            name: '< 15 мин.', value: row.less, name2: 'Доля от обслуженных :', value2: row.lesspersent,
          },
          {
            name: '15 мин.< и < 30 мин.', value: row.range, name2: 'Доля от обслуженных :', value2: row.rangepersent,
          },
          {
            name: '> 30 мин.', value: row.more, name2: 'Доля от обслуженных :', value2: row.morepersent,
          },
        ]),
        width: 320,
      },
      {
        dataIndex: 'solved_questions',
        title: 'Кол-во решенных вопросов',
        width: 140,
      },
      {
        dataIndex: 'all_cnt',
        title: 'Обслужено',
        render: (cell, row) => withButtonsTamplate(row, '123', 'WorkPlace', row.all_cnt, row.close_cnt, row.neyavka_cnt),
        width: 220,
      },
      {
        dataIndex: '13',
        title: 'Длительность ожидания',
        render: (cell, row) => TripleLineTemplate('Общая:', row.total_wait_time, 'Максимальная:', row.maxtotalwait_format, 'Средняя:', row.avg_wait_time),
        width: 200,
      },
      {
        dataIndex: '12',
        title: 'Длительность обслуживания',
        render: (cell, row) => TripleLineTemplate('Общая:', row.total_proc_time, 'Максимальная:', row.maxtotalproc_format, 'Средняя:', row.avg_proc_time),
        width: 200,
      },
    ],
  };
}
